export default __webpack_public_path__ + "static/media/pdf-icon.bef97b7f.svg";